import { SessionState } from '@uplift/types';

export const SESSION_STATES: Partial<Record<SessionState, SessionState>> = {
  initial: 'initial',
  started: 'started',
  scheduled: 'scheduled',
  completed: 'completed',
  expired: 'expired',
  cancelled: 'cancelled',
  failed: 'failed',
  submited: 'submited',
  payed: 'payed',
};
